import type * as api from '@gitbook/api-client';
import { Breadcrumbs } from '@gitbook/spine-react';

import { SpaceBreadcrumbItem, SpaceSiteBreadcrumbItem } from '../../../Components';

/**
 * Breadcrumbs for a space.
 */
export function BreadcrumbsSpace(props: { space: api.Space }) {
    const { space } = props;

    return (
        <Breadcrumbs label="Space breadcrumbs">
            <SpaceSiteBreadcrumbItem space={space} />
            <SpaceBreadcrumbItem space={space} editable iconOnly={false} />
        </Breadcrumbs>
    );
}
